import React from "react";
import { Table, Button, Modal, Form } from "react-bootstrap";
import "../../App.scss";
import AuthorizedPage from "../../component/AuthorizedPage";
import BuyerApprovalApi from "../../api/BuyerApprovalApi";
import { Role } from "../../domain/Role";
import { updateState } from "../StateHelper";
import Pager from "../../component/Pager";

interface Buyer {
  id?: number;
  version?: number;
  title?: string;
  code?: string;
  name?: string;
  surname?: string;
  phone1?: string;
  phone2?: string;
  email?: string;
  tckn?: string;
  vkn?: string;
  taxOffice?: string;
  addressMain?: string;
  addressSecondary?: string;
  isNew? :boolean;
}

interface State {
  pendingBuyers: Buyer[];
  selectedBuyer: Buyer | null;
  showModal: boolean;
  filter: 'new' | 'modified';
  page: number;
  totalPages: number;
  search: string;
  pageSize: number;
}

class BuyerApproval extends React.Component<any, State> {
  state: State = {
    pendingBuyers: [],
    selectedBuyer: null,
    showModal: false,
    filter: 'new',
    page: 1,
    totalPages: 1,
    search: "",
    pageSize: 20
  };

  private searchDebounceTimer: ReturnType<typeof setTimeout> | null = null;

  componentDidMount() {
    this.loadPendingBuyers();
  }

 loadPendingBuyers = async () => {
   const isNew = this.state.filter === 'new';
   const response = await BuyerApprovalApi.listPending(isNew, this.state.page, this.state.pageSize, this.state.search);
   if (response.success) {
     updateState(this, "pendingBuyers", response.data.buyers);
     const totalPages = response.data?.totalPages ?? 10;
     updateState(this, "totalPages", totalPages);
   }

 };

  getFilteredBuyers = (): Buyer[] => {
    const { pendingBuyers, filter } = this.state;
    if (filter === 'new') {
      return pendingBuyers.filter(buyer => buyer.isNew);
    }
    if (filter === 'modified') {
      return pendingBuyers.filter(buyer => !buyer.isNew);
    }
    return pendingBuyers;
  };

  handleSearchChange = (value: string) => {
    updateState(this, "search", value);
    if (this.searchDebounceTimer) clearTimeout(this.searchDebounceTimer);
    this.searchDebounceTimer = setTimeout(() => {
      this.setState({ page: 1 }, () => this.loadPendingBuyers());
    }, 400);
  };

  openModal = async (buyer: Buyer) => {
    if (!buyer.id) return;
    const response = await BuyerApprovalApi.getPendingById(buyer.id);
    if (response.success) {
      updateState(this, "selectedBuyer", response.data);
      updateState(this, "showModal", true);
    }
  };

  onSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const buyer = this.state.selectedBuyer;
    if (!buyer) return;
    const response = await BuyerApprovalApi.approve(buyer);
    if (response.success) {
      updateState(this, "showModal", false);
      updateState(this, "selectedBuyer", null);
      this.loadPendingBuyers();
    }
  };


renderModal() {
  const buyer = this.state.selectedBuyer;
  if (!buyer) return null;

  const handleChange = (field: keyof Buyer, value: any) => {
    updateState(this, "selectedBuyer", { ...buyer, [field]: value });
  };

  return (
    <Modal
      show={this.state.showModal}
      onHide={() => updateState(this, "showModal", false)}
    >
      <Modal.Header closeButton>
        <Modal.Title>Müşteri Onayı</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={this.onSubmit}>
          <Form.Control type="hidden" name="id" value={buyer.id || ""} />

          <Form.Group className="mb-3">
            <Form.Label>Unvan</Form.Label>
            <Form.Control
              name="title"
              value={buyer.title || ""}
              onChange={(e) => handleChange("title", e.target.value)}
              required
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Müşteri Kodu</Form.Label>
            <Form.Control
              name="code"
              value={buyer.code || ""}
              onChange={(e) => handleChange("code", e.target.value)}
              required
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Ad</Form.Label>
            <Form.Control
              name="name"
              value={buyer.name || ""}
              onChange={(e) => handleChange("name", e.target.value)}
              required
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Soyad</Form.Label>
            <Form.Control
              name="surname"
              value={buyer.surname || ""}
              onChange={(e) => handleChange("surname", e.target.value)}
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>E-Mail</Form.Label>
            <Form.Control
              name="email"
              value={buyer.email || ""}
              onChange={(e) => handleChange("email", e.target.value)}
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Telefon</Form.Label>
            <Form.Control
              name="phone1"
              value={buyer.phone1 || ""}
              onChange={(e) => handleChange("phone1", e.target.value)}
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Adres</Form.Label>
            <Form.Control
              as="textarea"
              rows={2}
              name="addressMain"
              value={buyer.addressMain || ""}
              onChange={(e) => handleChange("addressMain", e.target.value)}
            />
          </Form.Group>

          <Button type="submit" variant="secondary" style={{ float: "right" }}>
            Müşteriyi Onayla
          </Button>
        </Form>
      </Modal.Body>
    </Modal>
  );
}


  render() {
    return (
      <AuthorizedPage role={Role.ACCOUNTING_MANAGER}>
        <div className="centered-95-percent">

          <h3 className="mb-2">Müşteri Onay Sayfası</h3>

          <div className="d-flex align-items-center justify-content-between gap-2 mb-2">
            <div className="search-container">
              <input
                type="text"
                placeholder="Ara..."
                className="search-input"
                style={{ borderRadius: "20px" }}
                value={this.state.search}
                onChange={(e) => this.handleSearchChange(e.target.value)}
              />
              <div className="search-icon"></div>
            </div>
            <div className="d-flex align-items-center gap-2">
              <Button
                variant={this.state.filter === 'new' ? 'primary' : 'outline-primary'}
                style={{ borderRadius: "20px" }}
                onClick={() => {
                  this.setState({ filter: 'new', page: 1 }, () => this.loadPendingBuyers());
                }}
              >
                Yeni Müşteriler
              </Button>
              <Button
                variant={this.state.filter === 'modified' ? 'primary' : 'outline-primary'}
                style={{ borderRadius: "20px" }}
                onClick={() => {
                  this.setState({ filter: 'modified', page: 1 }, () => this.loadPendingBuyers());
                }}
              >
                Değiştirilmiş Kayıtlar
              </Button>
            </div>
          </div>

        <Table striped bordered hover>
          <thead>
            <tr>
              <th>Kodu</th>
              <th>Unvan</th>
              <th>Ad-Soyad</th>
              <th>E-Mail</th>
              <th>Telefon</th>
              <th>İşlem</th>
            </tr>
          </thead>
          <tbody>
            {this.getFilteredBuyers().map((b) => (
              <tr key={b.id}>
                <td>{b.code}</td>
                <td>{b.title}</td>
                <td>{b.name} {b.surname}</td>
                <td>{b.email}</td>
                <td>{b.phone1}</td>
                <td>
                  <Button size="sm" variant="info" onClick={() => this.openModal(b)}>
                    Onayla / Düzenle
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>

          <div className="d-flex align-items-center gap-2">
            <Form.Select
              style={{ width: "auto" }}
              value={this.state.pageSize}
              onChange={(e) => {
                this.setState({ pageSize: Number(e.target.value), page: 1 }, () => this.loadPendingBuyers());
              }}
            >
              <option value={10}>10</option>
              <option value={20}>20</option>
              <option value={50}>50</option>
              <option value={100}>100</option>
            </Form.Select>
            <Pager
              page={this.state.page}
              totalPages={this.state.totalPages}
              onChange={(newPage) => {
                this.setState({ page: newPage }, () => this.loadPendingBuyers());
              }}
            />
          </div>

        </div>

        {this.renderModal()}
      </AuthorizedPage>
    );
  }

}

export default BuyerApproval;
